import { Button } from "antd";
import React from "react";
import CustomTypography from "../CustomTypography";

const CustomButton = ({ children, className, loading, titleClass, disabled = false, size = "large", titleStyle = {}, btnStyle, type, variant = "outlined", titleProps, ...btnProps }) => {
    return (
        <Button className={className} loading={loading} size={size} disabled={disabled} type={type} variant={variant} style={{ borderRadius: "8px", ...btnStyle }} {...btnProps}>
            <p style={titleStyle} className={titleClass} {...titleProps}>
                {children}
            </p>
        </Button>
    );
};

export default CustomButton;
